import * as z from "zod/v4";

export const getVariantById = {
  name: "getVariantById" as const,
  input: z.object({ variantId: z.string(), teamId: z.string() }),
  output: z
    .object({ variantId: z.string(), name: z.string(), imageSrc: z.string() })
    .nullable(),
};
